<template>
    <button class="btn btn-primary"
        @click.prevent="$emit('click-button')"
    >
        {{label}}
    </button>
</template>

<script>
	export default {
		mixins: [],
		components: {
		},
		props: {
            // ボタンラベル
			label: {type: String, required:true},
		},
		data () {
			return {
			};
		},
		computed: {
		},
		methods: {
		},
		mounted() {
		}
	};
</script>

<style lang="scss" scoped>
	button {
    }
</style>
